import { render, staticRenderFns } from "./EmployeesFundWallet.vue?vue&type=template&id=0aa4ac51&scoped=true"
import script from "./EmployeesFundWallet.vue?vue&type=script&lang=js"
export * from "./EmployeesFundWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa4ac51",
  null
  
)

export default component.exports